import React from "react";
// import { ArrowRight } from "lucide-react"; // ✅ lightweight icon
import { FaChevronCircleUp } from "react-icons/fa";

const ReflectionScreen = ({ onStartAnalysis, subsection, onToggleImmersive }) => {
  const handleStartReflection = () => {
    onToggleImmersive?.(true);
    onStartAnalysis?.();
  };

  return (
    <div className="w-full min-h-[805px] flex flex-col items-center justify-center py-12 px-8 bg-white rounded-[20px]">
      {/* Image */}
      <img
        src={require("../../../../assets/reflection.png")}
        alt="Reflection companion"
        className="w-[225px] h-[320px] object-contain mx-auto mb-10"
        loading="lazy"
      />
<h1 className="text-[28px] leading-[135%] font-medium font-gotham text-[#323232] mb-6 text-center">
  Welcome to the Reflection Room
</h1>

      {/* Description */}
      <p className="text-base leading-[165%] font-normal text-[#323232] text-center max-w-2xl mb-10 px-4 font-gotham">
        This is a place to pause, contemplate, and evolve. I’m Shizun, your
        companion for introspection — ready to listen and support you on your journey.
      </p>

      {/* Elegant Start Button */}
      <button
        onClick={handleStartReflection}
        className="group flex items-center justify-between gap-3 bg-[#54B0AF] hover:bg-teal-600 
                   text-white font-medium rounded-2xl px-6 py-[18px] min-w-[240px]
                   transition-all duration-200 shadow-md hover:shadow-lg focus:outline-none
                   focus:ring-2 focus:ring-[#54B0AF]/50 font-gotham text-base lg:text-lg 2xl:text-[21px]"
      >
        <span className="">Start Reflecting</span>
        {/* <ArrowRight
          className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-1"
        /> */}
        <FaChevronCircleUp className="rotate-90 ml-2" />
      </button>
    </div>
  );
};

export default ReflectionScreen;
